import { clientConstants } from '../_constants';

const initialState = {
  clients: [],
  errors: {}
};


export function client(state = initialState, action) {
  switch (action.type) {

  case clientConstants.CLIENT_OPTIONS_LOADED:
    return Object.assign({}, state, { options: action.data.actions.POST });

  case clientConstants.CLIENTS_LOADED:
    return Object.assign({}, state, { clients: action.data.results});

  case clientConstants.CLIENT_CREATED:
    let { clients } = state;
    clients.unshift(action.data);
    return Object.assign({}, state, { clients, message: 'Client successfully created.' });

  case clientConstants.CLIENT_LOADED:
    return Object.assign({}, state, { client: action.data});

  case clientConstants.CLIENT_UPDATED:
    clients = state.clients.slice();
    let idx = clients.findIndex(item => item.id === action.data.id);
    clients[idx] = action.data;
    return Object.assign({}, state, { clients, message: 'Client successfully updated.' });

  case clientConstants.CLIENT_ERRORS:
    return Object.assign({}, state, { errors: action.errors });

  case clientConstants.CLIENT_DELETED:
    clients = state;
    idx = clients.findIndex(item => item.id === action.data.id);
    delete clients[idx];
    return Object.assign({}, state, { clients, message: 'Client successfully deleted.' });

  case clientConstants.CLIENT_RESET:
    return Object.assign({}, state, { message: '', errors: {} });

  case 'ACCOUNTS_LOADED':
    return Object.assign({}, state, { accounts: action.data.results });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/client.reducer.js